import { BoardCard } from './board-card';
import { BoardColumn } from './board-column';
import { BoardJSON } from './json';

export class Board {

  public columns: BoardColumn[];

  public get isEmpty(): boolean {
    return this.columns.every((column) => column.cards.length === 0);
  }

  public constructor(columns: BoardColumn[]) {
      this.columns = columns;
  }

  public findCardCoordinate(id: string): { column: number, row: number } | undefined {
    for (let colIndex = 0; colIndex < this.columns.length; colIndex++) {
      for (let cardIndex = 0; cardIndex < this.columns[colIndex].cards.length; cardIndex++) {
        if (this.columns[colIndex].cards[cardIndex].id === id) {
          return { column: colIndex, row: cardIndex };
        }
      }
    }
    return undefined;
  }

  public replaceCard(hash: string, card: BoardCard): void {
    const coordinate = this.findCardCoordinate(hash);
    if (!coordinate) { return; }

    this.columns[coordinate.column].cards[coordinate.row] = card;
  }

  public findCardById(id: string): BoardCard | undefined {
    const cards = this.columns.map((column) => column.cards).flat();
    return cards.find((card) => card.id === id);
  }

  public addCard(columnIndex: number, card: BoardCard): void {
    this.columns[columnIndex].cards.push(card);
  }

  public removeCardById(id: string): void {
    const coordinate = this.findCardCoordinate(id);
    if (!coordinate) { return; }

    this.removeCard(coordinate.column, coordinate.row);
  }

  public removeCard(columnIndex: number, cardIndex: number): void {
    const columnCards = [...this.columns[columnIndex].cards];
    columnCards.splice(cardIndex, 1);
    this.columns[columnIndex].cards = columnCards;
  }

  public toJSON(): BoardJSON {
    return {
      columns: this.columns.map((column) => column.toJSON()),
    };
  }
}